module.exports = __webpack_public_path__ + "img/sayan-nath-MCfy9IZivT0-unsplash.c09ea3a2.jpg";